import React from 'react';

import styles from './DescriptionField.module.scss';

const DescriptionField = ({ placeHolder = '', children }) => (
  <div className={styles.rootContainer}>
    <span className={styles.placeHolder}>{placeHolder}</span>
    {children}
  </div>
);

export default DescriptionField;
